import { EnvContribution, getLegacyBindingContext } from "@visactor/vrender-core";

import { bindBrowserCanvasModules } from "../canvas/contributions/browser/modules";

import { loadCanvasPicker } from "../picker/canvas-module";

import { bindBrowserWindowContribution } from "../window/contributions/browser-contribution";

import { BrowserEnvContribution } from "./contributions/browser-contribution";

export function bindBrowserEnv(container) {
    var _a, _b;
    (null === (_b = (_a = container).isBound) || void 0 === _b ? void 0 : _b.call(_a, BrowserEnvContribution)) || (container.bind(BrowserEnvContribution).toSelf().inSingletonScope(), 
    container.bind(EnvContribution).toService(BrowserEnvContribution));
}

export function loadBrowserEnv(container = getLegacyBindingContext(), loadPicker = !0) {
    loadBrowserEnv.__loaded || (loadBrowserEnv.__loaded = !0, bindBrowserEnv(container), 
    bindBrowserCanvasModules(container), bindBrowserWindowContribution(container), loadPicker && loadCanvasPicker(container));
}

loadBrowserEnv.__loaded = !1;

export function initBrowserEnv() {
    loadBrowserEnv();
}
//# sourceMappingURL=browser.js.map